module.exports = __webpack_public_path__ + "static/media/fa-solid-900.a265bbc2.woff2";